import React from "react";
import MainLayout from "../../layout/mainLayout";
import "./index.scss";
import AttributeForm from "./component/attributeForm";

const Attribute = () => {
  return (
    <div className="main-layout-wrapper">
      <MainLayout>
        <div className="attribute--form-wrapper">
          <AttributeForm />
        </div>
      </MainLayout>
    </div>
  );
};

export default Attribute;
